var _rect, _rect2, _g, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "#F7FAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 64,
    width: 1136,
    height: 592,
    rx: 40,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126 64V656",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 138H1208",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 232H1208",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 326H1208",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 420H1208",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 514H1208",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 608H1208",
    stroke: "#D8E6FF",
    strokeWidth: 2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1092,
    cy: 152,
    r: 78,
    fill: "#DAEAFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 564,
    r: 112,
    fill: "#E1F3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGrid);
export default __webpack_public_path__ + "static/media/bg-grid.76e8c94448f292325206df35dbe3e766.svg";
export { ForwardRef as ReactComponent };